<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.productReview')" />
      <v-tabs v-model="selectedTab" centered class="transparent">
        <v-tab class="text-h6 text-capitalize font-weight-bold tab">{{ $t('label.toReview') }}</v-tab>
        <v-tab class="text-h6 text-capitalize font-weight-bold tab">{{ $t('label.history') }}</v-tab>
      </v-tabs>
      <v-container class="rounded-lg my-8 pa-5 elevation-3" v-if="selectedTab === 0 && toReview.length > 0">
        <ProductReviewListItem v-for="item in toReview" :item="item" :key="item.id" />
      </v-container>
      <div v-else-if="selectedTab === 0" class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('label.noRecords') }}</div>
      <v-container class="rounded-lg my-8 pa-5 elevation-3" v-if="selectedTab === 1 && history.length > 0">
        <ProductReviewListItem v-for="item in history" :item="item" :key="item.id" :toReview="false" />
      </v-container>
      <div v-else-if="selectedTab === 1" class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('label.noRecords') }}</div>
    </LayoutContent>
  </div>
</template>

<script>
import { REVIEW } from '@/api'
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
import ProductReviewListItem from '@/components/review/ProductReviewListItem.vue'

export default {
  components: { LayoutContent, SectionTitle, ProductReviewListItem },

  data() {
    return {
      selectedTab: '',
      toReview: [],
      history: []
    }
  },
  created() {
    // get to review
    REVIEW.getMyReview({ type: 1, review_type: 1 }).then((res) => {
      if (res.total_count > 0) {
        this.toReview = res.list.map((order) => {
          return {
            order_id: order.order_id,
            po_number: order.po_number,
            items: order.item
          }
        })
      }
    })
    // get history
    REVIEW.getMyReview({ type: 1, review_type: 2 }).then((res) => {
      if (res.total_count > 0) {
        this.history = res.list.map((order) => {
          return {
            order_id: order.order_id,
            po_number: order.po_number,
            items: order.item
          }
        })
      }
    })
  },
  methods: {}
}
</script>

<style lang="scss">
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}
.tab {
  width: 50%;
}
</style>
<style lang="scss" scoped>
.blank-message {
  margin: 150px;
}
</style>
